import React, { useState, useEffect } from "react";
import { Button, Col, Form, Modal, Row, Image } from "react-bootstrap";
import {
  TextField,
  FormControl,
  Select,
  InputLabel,
  makeStyles,
  MenuItem,
} from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import SimpleReactLightbox from "simple-react-lightbox";
import { serverApi, imageUploadSize } from "../../../../config/Keys";
import { MultipleImageUploadComponent } from "../../../reusableComponents/imageUploadReusableComponent/MultipleImageUploadComponent";

import { add_vendor_issues_suggestions } from "../../../../store/actions/VendorIssuesSuggestionActions/VendorIssuesSuggestionActions";
import { get_all_categories } from "../../../../store/actions/categoryActions";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useFormik } from "formik";
import * as yup from "yup";
import axios from "axios";
import Alert from "react-s-alert";

const validationSchema = yup.object({
  issueType: yup.string().required("Please select Issue Type"),
  title: yup
    .string()
    .required("Title is required")
    .min(1, "Minimum 1 Character")
    .max(64, "Maximum 64 Character"),
  description: yup
    .string()
    .required("Description is required")
    .min(1, "Minimum 1 Character")
    .max(512, "Maximum 512 Character"),
  categoryId: yup.string().required("Please select category"),
});

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const AddVendorSuggestionIssuesPopup = (props) => {
  const classes = useStyles();
  //state
  const [file, setFile] = useState(null);
  const [state, setState] = useState({
    actionButton: false,
    category: "",
    restaurant_pictures: [],
    restaurant_pictures_new: [],
    combined: "",
  });

  /*************************************
   * @DESC Multiple Image Upload
   ************************************/
  const onCompleteUploadMultipleCrop = (e) => {
    let oldData = state.restaurant_pictures;
    oldData.push(e);
    setState({
      ...state,
      restaurant_pictures: oldData,
      actionButton: true,
    });
  };

  const cancelFiles = (file) => {
    let restaurant_pictures_temp = state.restaurant_pictures_new;
    let newToUpload = restaurant_pictures_temp.filter((item, index) => {
      return item.name !== file.name;
    });
    setState({ ...state, restaurant_pictures_new: newToUpload });
  };

  const uploadMultipleFiles = (e) => {
    const vendor_id = props.auth.user.VendorUser._id;
    const restaurant_name = props.onboarding.restaurant_name
      .split(" ")
      .join("");
    const combined = vendor_id + "_" + restaurant_name;
    const data = new FormData();
    let flag = false;
    var newUploaded = [];
    for (let i = 0; i < e.target.files.length; i++) {
      if (e.target.files[i].size > imageUploadSize) {
        alert("File is too Big");
        return (flag = false);
      } else if (e.target.files.length > 5) {
        alert("You can upload only 10 files");
        return (flag = false);
      } else {
        let allPicures = state.restaurant_pictures;
        allPicures.some((phone) => {
          if (
            phone.split(`${restaurant_name}-`)[1] === e.target.files[i].name
          ) {
            // flag = true;
            return (flag = true);
          } else {
            return (flag = false);
          }
        });
        if (!flag) {
          newUploaded.push(e.target.files[i]);
          data.append("files", e.target.files[i]);
        }
      }
    }
    if (!flag) {
      setState({
        ...state,
        restaurant_pictures_new: newUploaded,
        combined: combined,
      });
    } else {
      Alert.error(`<h4>Can not upload the same image</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
    e.target.value = "";
  };

  const multipleResetFile = (indexId) => {
    let allPicures = state.restaurant_pictures;
    let allPicuresObj = allPicures.find((images, index) => index === indexId);
    if (allPicuresObj === 0 || allPicuresObj) {
      allPicures.splice(allPicures.indexOf(allPicuresObj), 1);
      setState({ ...state, allPicures: allPicures, actionButton: true });
    }
  };

  const handleChangeCategoryAdd = (event) => {
    setState({
      ...state,
      category: event.target.value,
    });
    formik.setFieldValue("categoryId", event.target.value);
  };
  const [ShowAddIssue, setShowAddIssue] = useState(false);

  const handleShowAddIssue = () => {
    setShowAddIssue(true);
  };
  const handleCloseAddIssue = () => {
    setShowAddIssue(false);
  };
  const onSuccessAddSuggestion = () => {
    formik.resetForm();
    setState({
      category: "",
      restaurant_pictures: [],
      restaurant_pictures_new: [],
      combined: "",
    });
    handleCloseAddIssue();
    // props.appendSuggestionNew();
  };

  const formik = useFormik({
    initialValues: {
      issueType: "",
      title: "",
      categoryId: "",
      description: "",
      attachment: [],
      status: 0,
    },
    validationSchema,

    onSubmit: (values) => {
      const token = props.auth.user.accessToken;
      const formData = {
        type: values.issueType,
        issue_title: values.title,
        category: values.categoryId,
        comment: values.description,
        attachment: state.restaurant_pictures,
      };
      props.add_vendor_issues_suggestions(
        formData,
        token,
        onSuccessAddSuggestion
      );
    },
  });

  const [count, setCount] = useState(1);
  const onClickSave = () => {
    setCount(count + 1);
    formik.handleSubmit();
  };
  const [category, setCategory] = useState([]);
  const onSuccessGetFavChain = (data) => {
    var cateogryIcons = [];
    for (var i = 0; i < data.length; i++) {
      cateogryIcons.push({ name: data[i].title, id: data[i]._id });
    }
    setCategory(cateogryIcons);
  };

  useEffect(() => {
    props.get_all_categories(onSuccessGetFavChain);
    formik.setFieldValue("title", "");
  }, []);
  // for set focus
  useEffect(() => {
    if (formik.errors && formik.errors.issueType) {
      let issueTypeElement = document.getElementById("issueType");
      issueTypeElement.focus();
    } else if (formik.errors && formik.errors.title) {
      let titleElement = document.getElementById("title");
      titleElement.focus();
    } else if (formik.errors && formik.errors.categoryId) {
      let catElement = document.getElementById("categoryId");
      catElement.focus();
    } else if (formik.errors && formik.errors.description) {
      let descDateElement = document.getElementById("description");
      descDateElement.focus();
    }
  }, [count]);

  return (
    <React.Fragment>
      <Button
        variant="danger"
        className={`${
          props.newButton
            ? `btn btn-danger text-normal btn-xs rounded`
            : `btn2 btn-lg`
        } `}
        onClick={handleShowAddIssue}
      >
        + Add Ticket
      </Button>
      <Modal
        show={ShowAddIssue}
        onHide={handleCloseAddIssue}
        centered
        size="md"
      >
        <Modal.Header className="border-0 pb-0" closeButton>
          <Modal.Title className="f22-500">Add Ticket</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col md={12}>
                <FormControl variant="outlined" className={"w-100 mb-3"}>
                  <InputLabel htmlFor="outlined-description">Issues</InputLabel>
                  <Select
                    value={formik.values.issueType}
                    onChange={formik.handleChange}
                    label="Issues"
                    name="issueType"
                    id="issueType"
                    IconComponent={KeyboardArrowDownIcon}
                    onBlur={formik.handleBlur}
                  >
                    <MenuItem value="ISSUE">Issues</MenuItem>
                    <MenuItem value="SUGGESTION">Suggestions</MenuItem>
                  </Select>
                  {formik.errors.issueType && formik.touched.issueType ? (
                    <div className="pho_14_regular text-danger">
                      {formik.errors.issueType}
                    </div>
                  ) : null}
                </FormControl>
                <Form.Group>
                  <TextField
                    id="title"
                    variant="outlined"
                    label="Title"
                    name="title"
                    className={`w-100  ${
                      formik.errors.title && formik.touched.title
                        ? "enError"
                        : ""
                    }`}
                    onChange={formik.handleChange}
                    value={formik.values.title}
                    onBlur={formik.handleBlur}
                    //onInvalid={formik.errors.email && formik.touched.email}
                    isInvalid={formik.errors.title && formik.touched.title}
                  />
                  {formik.errors.title && formik.touched.title ? (
                    <div className="pho_14_regular text-danger">
                      {formik.errors.title}
                    </div>
                  ) : null}
                </Form.Group>
                <Form.Group>
                  <FormControl
                    variant="outlined"
                    className={classes.formControl}
                  >
                    <InputLabel htmlFor="outlined-Category">
                      Category
                    </InputLabel>
                    <Select
                      id="categoryId"
                      value={state.category}
                      onChange={handleChangeCategoryAdd}
                      label="Category"
                      inputProps={{
                        name: "category",
                        id: "outlined-Category",
                      }}
                      IconComponent={KeyboardArrowDownIcon}
                    >
                      {category.map((item, index) => (
                        <option label={item.name} value={item.id} key={index}>
                          {item.name}
                        </option>
                      ))}
                    </Select>
                    {formik.errors.categoryId && formik.touched.categoryId ? (
                      <div className="pho_14_regular text-danger">
                        {formik.errors.categoryId}
                      </div>
                    ) : null}
                  </FormControl>
                </Form.Group>
                <Form.Group>
                  <TextField
                    id="description"
                    variant="outlined"
                    label="Description"
                    multiline
                    rows="5"
                    name="description"
                    className={`w-100  ${
                      formik.errors.description && formik.touched.description
                        ? "enError"
                        : ""
                    }`}
                    onChange={formik.handleChange}
                    value={formik.values.description}
                    onBlur={formik.handleBlur}
                    //onInvalid={formik.errors.email && formik.touched.email}
                    isInvalid={
                      formik.errors.description && formik.touched.description
                    }
                  />
                  {formik.errors.description && formik.touched.description ? (
                    <div className="pho_14_regular text-danger">
                      {formik.errors.description}
                    </div>
                  ) : null}
                </Form.Group>
              </Col>
              <Col md={12}>
                <SimpleReactLightbox>
                  <MultipleImageUploadComponent
                    title="Add Photos"
                    onChange={uploadMultipleFiles}
                    stateValue={
                      state.restaurant_pictures && state.restaurant_pictures
                    }
                    newUploaded={
                      state.restaurant_pictures_new
                        ? state.restaurant_pictures_new
                        : []
                    }
                    combined={state.combined}
                    onCompleteUploadMultipleCrop={onCompleteUploadMultipleCrop}
                    removeImage={multipleResetFile}
                    accept="image/gif,image/jpeg,image/jpg,image/png,.pdf"
                    cancelFiles={cancelFiles}
                  />
                  <div className="font_12_r c_gray mb-4 d-flex">
                    (You can upload maximum 5 pic per issue 700 x 420 pixels)
                  </div>
                </SimpleReactLightbox>
              </Col>
              <Col md={12}>
                <div className="pt-4 d-flex align-items-center">
                  <Button
                    variant="outline-secondary"
                    className="btn150px btn-lg mr-4 px-5 "
                    onClick={handleCloseAddIssue}
                  >
                    Back
                  </Button>
                  <Button
                    variant="danger"
                    onClick={() => onClickSave()}
                    className="btn150px btn-lg px-5"
                  >
                    Save
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

AddVendorSuggestionIssuesPopup.propTypes = {
  auth: PropTypes.object.isRequired,
  get_all_categories: PropTypes.func.isRequired,
  add_vendor_issues_suggestions: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.onboarding.restaurantDetails,
  allSuggestions: state.categories.get_all_categories,
});

export default connect(mapStateToProps, {
  get_all_categories,
  add_vendor_issues_suggestions,
})(AddVendorSuggestionIssuesPopup);

// import React, { Component } from "react";
// import classnames from "classnames";
// import "react-responsive-modal/styles.css";
// import { Modal } from "react-responsive-modal";
// import { ReusableOnboardingButton } from "../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
// import {
//   InputBoxComponent,
//   TextAreaReusableComponent,
//   SelectCategory,
// } from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";
// import Form from "react-bootstrap/Form";
// import { IconButtonReusableComponent } from "../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";

// import PropTypes from "prop-types";
// import { connect } from "react-redux";
// import { withRouter } from "react-router-dom";
// import { clear_all_errors } from "../../../../store/actions/errorActions";
// import { add_vendor_issues_suggestions } from "../../../../store/actions/VendorIssuesSuggestionActions/VendorIssuesSuggestionActions";
// import { get_all_categories } from "../../../../store/actions/categoryActions";
// import isEmpty from "../../../../store/validation/is-Empty";

// export class AddVendorSuggestionIssuesPopup extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       open: false,
//       title: "",
//       allcategory: [],
//       category: "",
//       comment: "",
//       errors: [],
//     };
//   }

//   componentDidMount() {
//     if (!isEmpty(this.props.get_all_categories)) {
//       this.props.get_all_categories();
//     }
//   }

//   static getDerivedStateFromProps(nextProps, nextState) {
//     if (!isEmpty(nextProps.allCategory) !== nextState.allcategory) {
//       return {
//         allcategory: nextProps.allCategory,
//       };
//     }
//     return null;
//   }

//   onOpenModal = () => {
//     this.setState({ open: true, errors: [] });
//   };

//   onCloseModal = () => {
//     this.setState({ open: false, errors: [] });
//   };

//   onChange = (e) => {
//     this.setState({
//       [e.target.name]: e.target.value,
//     });
//   };

//   onFocusOut = (e) => {
//     const { errors } = this.state;
//     if (e.target.value === "") {
//       errors[e.target.name] = `${e.target.name} is required`;
//     } else {
//       errors[e.target.name] = "";
//     }
//     this.setState({
//       errors: errors,
//     });
//   };

//   callBackFunc = (e) => {
//     this.setState({
//       title: "",
//       category: "",
//       comment: "",
//     });
//     this.onCloseModal();
//   };

//   onSubmitHandler = (e) => {
//     e.preventDefault();
//     const token = this.props.auth.user.accessToken;
//     const formData = {
//       issue_title: this.state.title,
//       category: this.state.category,
//       comment: this.state.comment,
//     };
//     this.props.add_vendor_issues_suggestions(
//       formData,
//       token,
//       this.callBackFunc
//     );
//   };

//   render() {
//     const { open, errors, title, category, comment } = this.state;
//     return (
//       <React.Fragment>
//         <IconButtonReusableComponent
//           buttonText="Add Issue"
//           onClick={this.onOpenModal}
//           buttonType="button"
//         />
//         <Modal
//           open={open}
//           onClose={this.onCloseModal}
//           center
//           classNames={{
//             overlay: "onBoarding-CustomOverlay-request-accept-cancelled",
//             modal: "suggest-vendor-model-popup",
//             // closeButton: "onBoarding-Custom-CloseButtonCalling",
//             animationIn: "onBoardingCustomEnterAnimation",
//             animationOut: "onBoardingCustomLeaveAnimation",
//           }}
//           animationDuration={1000}
//         >
//           <div>
//             <div className="suggest-vendor-model-popup-header">
//               <h4>Vendor Issues / Suggest New</h4>
//             </div>
//             <div className="suggest-vendor-model-popup-bodybox">
//               <Form noValidate>
//                 <InputBoxComponent
//                   displayLabel={true}
//                   controlId="Title"
//                   labelText="Title"
//                   placeHolder="eg. Jhatka"
//                   name="title"
//                   onChange={this.onChange}
//                   onFocusOut={this.onFocusOut}
//                   value={this.state.title}
//                   required="required"
//                   showBottom={true}
//                   error={this.state.title === "" ? errors.title : " "}
//                   inputClassName={classnames("input-component-inputfield", {
//                     invalid: errors.title,
//                   })}
//                 />
//                 <Form.Group
//                   controlId="exampleForm.ControlSelect1"
//                   className="suggest-new-custom-select-box"
//                 >
//                   <SelectCategory
//                     controlId={"category"}
//                     allcategoryList={this.state.allcategory}
//                     inputlabelclass="input-component-labeltext"
//                     labeltext="Category"
//                     name="category"
//                     onFocusOut={this.onFocusOut}
//                     value={this.state.category}
//                     onChange={this.onChange}
//                     error={this.state.category === "" ? errors.category : " "}
//                     inputClass={classnames("input-component-inputfield w-100", {
//                       invalid: errors.category,
//                     })}
//                   />
//                   {/* <div className="position-relative">
//                     <input
//                       type="text"
//                       className="select-category-input-Box"
//                       id="exampleForm.ControlSelect1"
//                       placeholder="Select from list below"
//                       onChange={this.onChange}
//                       value={this.state.category}
//                       name="category"
//                     />
//                     <Image
//                       src={require("../../../../assets/images/ActionImages/dropdownButton.png")}
//                       alt="icon"
//                       fluid
//                       className="select-dropdown-button"
//                     />
//                   </div> */}
//                 </Form.Group>
//                 <TextAreaReusableComponent
//                   controlId="comment"
//                   displayText={true}
//                   labelText="Comment"
//                   labelTextClass="text-area-lable"
//                   placeholder="Eg. A Bright Atmosphere"
//                   rows="6"
//                   onChange={this.onChange}
//                   onFocusOut={this.onFocusOut}
//                   name="comment"
//                   value={this.state.comment}
//                   inputClassName={classnames("input-text-area text-area-new", {
//                     invalid: errors.comment,
//                   })}
//                   error={this.state.comment === "" ? errors.comment : " "}
//                 />
//               </Form>
//               <div className="d-flex justify-content-between mt-3">
//                 <ReusableOnboardingButton
//                   buttonText="Cancel"
//                   buttonTitle="Cancel Button"
//                   buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
//                   onClick={this.onCloseModal}
//                 />
//                 <ReusableOnboardingButton
//                   buttonText="Confirm"
//                   buttonTitle="Confirm Button"
//                   buttonClass={
//                     title === "" || category === "" || comment === ""
//                       ? "onboarding_button_link_reusable onboarding_button_link_reusable_gray"
//                       : "onboarding_button_link_reusable onboarding_button_link_reusable_red"
//                   }
//                   disabled={
//                     title === "" || category === "" || comment === ""
//                       ? true
//                       : false
//                   }
//                   onClick={
//                     title === "" || category === "" || comment === ""
//                       ? null
//                       : this.onSubmitHandler
//                   }
//                 />
//               </div>
//             </div>
//           </div>
//         </Modal>
//       </React.Fragment>
//     );
//   }
// }

// AddVendorSuggestionIssuesPopup.propTypes = {
//   auth: PropTypes.object.isRequired,
//   errors: PropTypes.object.isRequired,
// };

// const mapStateToProps = (state) => ({
//   auth: state.auth,
//   errors: state.errors.errors,
//   allCategory: state.categories.get_all_categories,
// });

// export default connect(mapStateToProps, {
//   clear_all_errors,
//   get_all_categories,
//   add_vendor_issues_suggestions,
// })(withRouter(AddVendorSuggestionIssuesPopup));
